import axios from 'axios';
import API from './API';


export const Schedules_Add = (data) => {
  const Token = localStorage.getItem("Token");
  return API.post("Schedules/Add", data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Schedules_Get_All = () => {
  const Token = localStorage.getItem("Token");
  return API.get(`Schedules/Get/All`, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

// export const Schedules_Get_Normal = () => {
//   return API.get("Schedules/Get/Normal");
// };
export const Schedules_Get = (ID) => {
  const Token = localStorage.getItem("Token");
  return API.get(`Schedules/Get/${ID}`, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Schedules_Get_ByUser = () => {
  const Token = localStorage.getItem("Token");
  return API.get(`Schedules/Get_ByUser`, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Schedules_Get_Pending_Initial = () => {
  const Token = localStorage.getItem("Token");
  return API.get(`Schedules/Get_Pending_Initial`, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Schedules_Get_Pending_Final = () => {
  const Token = localStorage.getItem("Token");
  return API.get(`Schedules/Get_Pending_Final`, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Schedules_Update = (ID, Data) => {
  const Token = localStorage.getItem("Token");
  return API.put(`Schedules/Update/${ID}`, Data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};
export const Schedules_Delete = (ID) => {
  const Token = localStorage.getItem("Token");
  return API.delete(`Schedules/Delete/${ID}`, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
}

export const Schedules_Approve_Initial = (ID) => {
  const Token = localStorage.getItem("Token");
  return API.put(`Schedules/Approve/1/${ID}`, {}, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Schedules_Approve_Final = (ID, Data) => {
  const Token = localStorage.getItem("Token");
  return API.put(`Schedules/Approve/2/${ID}`, Data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Schedules_Reject_Initial = (ID, Data) => {
  const Token = localStorage.getItem("Token");
  return API.put(`Schedules/Reject/1/${ID}`, Data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Schedules_Reject_Final = (ID, Data) => {
  const Token = localStorage.getItem("Token");
  return API.put(`Schedules/Reject/2/${ID}`, Data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};



export const Schedules_Conflict_Check = (Data) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Schedules/Conflict_Check`, Data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Schedules_Recommendation_Time_Get = (Data) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Schedules/Recommend/Time`, Data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Schedules_Recommendation_Room_Get = (Data) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Schedules/Recommend/Room`, Data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Schedules_Reschedule = (ID, Data) => {
  const Token = localStorage.getItem("Token");
  return API.put(`Schedules/Reschedule/${ID}`, Data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Schedules_Relocate = (ID, Data) => {
  const Token = localStorage.getItem("Token");
  return API.put(`Schedules/Relocate/${ID}`, Data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Schedules_Edit = (ID, Data) => {
  const Token = localStorage.getItem("Token");
  return API.put(`Schedules/Edit/${ID}`, Data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Schedules_Report_Monthly = (Data) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Schedules/Report/Monthly`, Data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
}

export const Schedules_Report_Weekly = (Data) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Schedules/Report/Weekly`, Data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
}

export const Schedules_Report_Room_Utilization = (Data) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Schedules/Report/RoomUtil`, Data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
}